import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { WEBSOCKET_URL } from "../util/constant";

async function Retry(action, retryInterval = 1000, maxAttemptCount = 60) {
  const exceptions = [];
  for (let attempted = 0; attempted < maxAttemptCount; attempted++) {
    try {
      if (attempted > 0)
        await sleep(retryInterval);
      return action();
    }
    catch (e) {
      exceptions.push(e);
    }
  }

  return exceptions;
}

function sleep(ms) { return new Promise(resolve => setTimeout(resolve, ms)); }


class WebSocketService {
  client = null;
  subscriptions = {};

  async connect() {
    if (this.client) return new Promise((resolve, reject) => {
      Retry(() => {
        if (!!this.client?.connected === false) {
          throw new Error('Websocket not yet connected')
        }
      }).then(r => resolve())
        .catch(e => reject(e))
    })

    const socket = new SockJS(WEBSOCKET_URL);
    this.client = new Client({
      webSocketFactory: () => socket,
      onConnect: () => {
        console.log('Websocket connected');
        Object.entries(this.subscriptions).forEach(([topic, callback]) => {
          this.client.subscribe(topic, callback);
        });
      },
      onDisconnect: () => {
        console.log('Disconnected from Websocket');
      },
      onWebSocketClose: () => {
        console.log('Websocket closed');
        this.client.activate();
      },
      reconnectDelay: 5000,
    });
    this.client.activate();

    return new Promise((resolve, reject) => {
      Retry(() => {
        if (!!this.client?.connected === false) {
          throw new Error('Websocket not yet connected')
        }
      }).then(r => resolve())
        .catch(e => reject(e))
    })
  }

  subscribe(topic, callback) {
    console.log('Subscribing to topic:', topic);
    this.subscriptions[topic] = callback;
    if (this.client && this.client.connected) {
      this.client.subscribe(topic, callback);
    }
  }

  send(destination, body) {
    if (this.client && this.client.connected) {
      this.client.publish({ destination, body });
    }
  }
}

const websocketService = new WebSocketService();
export default websocketService;
